import { useMutation } from "@apollo/client";
import { REMOVE_USER_SITE } from "../user-sites.queries";
import {
  RemoveUserSiteMutation,
  RemoveUserSiteMutationVariables,
} from "../../../__generated__/RemoveUserSiteMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useRemoveUserSite = ({ id, onCompleted }: IProps) => {
  const [mutate, { loading }] = useMutation<
    RemoveUserSiteMutation,
    RemoveUserSiteMutationVariables
  >(REMOVE_USER_SITE);

  const submit = async () => {
    if (loading) return;
    try {
      const { data } = await mutate({
        variables: {
          id,
        },
      });

      if (data?.removeUserSite?.ok) {
        onCompleted();
      } else {
        throw Error(data?.removeUserSite?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    mutate,
    loading,
    submit,
  };
};
